import {
	PostRequestPreRegister,
	PostRequestPreRegisterParams,
	PostRequestPreRegisterResponse,
} from 'domain/usecases/others/facial-biometric/';

import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

export class RemoteFacialBiometricPostPreRegister implements PostRequestPreRegister {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostRequestPreRegisterResponse>,
	) {}

	async post(params: PostRequestPreRegisterParams): Promise<PostRequestPreRegisterResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
